module.exports = __webpack_public_path__ + "img/bag-plus.3c0bfc8b.svg";